import { createFeature, createReducer, on } from '@ngrx/store';
import { getProfileSuccess, getUserSuccess, updateProfileSuccess } from './user.actions';

export interface IUserState {
  first_name: string;
  is_email_verified: boolean | null;
  position: string | null;
  tariff_ends_at: string | null;
  tariff_name: string | null;
  last_name: string;
  sphere: number | null;
  projects_count: number;
  max_projects: number;
  is_onboarding_completed: boolean | null;
}

const initialState: IUserState = {
  first_name: '',
  is_email_verified: null,
  position: null,
  tariff_ends_at: null,
  tariff_name: null,
  last_name: '',
  sphere: null,
  projects_count: 0,
  max_projects: 0,
  is_onboarding_completed: true,
};

export const userFeature = createFeature({
  name: 'user',
  reducer: createReducer(
    initialState,
    on(getUserSuccess, (state, { user }) => ({ ...state, ...user })),
    on(getProfileSuccess, (state, { profile }) => ({ ...state, ...profile })),
    on(updateProfileSuccess, (state, { profile }) => ({ ...state, ...profile })),
  ),
});
